import { useCallback, useState } from "react";
import { generatedPaymentForm } from "../lib/paymentForm";

const PAYMENT_AMOUNT_FIELDS = new Set([
  "interest_amount",
  "penalty_amount",
  "main_debt",
  "referral_commission",
]);

export const usePaymentForm = (initialForm) => {
  const [form, setForm] = useState(initialForm);
  const [generated, setGenerated] = useState(false);

  const update = useCallback((field, value) => {
    if (PAYMENT_AMOUNT_FIELDS.has(field)) {
      setGenerated(false);
    }
    setForm((current) => ({ ...current, [field]: value }));
  }, []);

  const generate = useCallback(() => {
    setForm((current) => generatedPaymentForm(current));
    setGenerated(true);
  }, []);

  const replace = useCallback((nextForm) => {
    setForm(nextForm);
    setGenerated(false);
  }, []);

  return {
    form,
    generate,
    generated,
    replace,
    setGenerated,
    update,
  };
};